import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-i-choose',
  templateUrl: './how-i-choose.component.html',
  styleUrls: ['./how-i-choose.component.scss']
})
export class HowIChooseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
